import React from 'react';
import { Card, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { themeConfig } from '../config/theme';

const { Title, Paragraph } = Typography;

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '50px', background: themeConfig.login.bgColor, minHeight: '100vh' }}>
      <Card>
        <div style={{ marginBottom: '20px' }}>
          <Link to="/login">
            <Button icon={<ArrowLeftOutlined />}>Back to Login</Button>
          </Link>
        </div>
        <Typography>
          <Title>Privacy Policy</Title>
          <Paragraph>
            This Privacy Policy outlines how Devaram Interiors HRMS ("we", "our", or "us") collects, uses, and protects your information when you use our internal HRMS mobile application and web dashboard. This system is exclusively for the internal use of employees, supervisors, and owners of Devaram Interiors, located at 4th Floor, 405, Om Sai Sadan, N. M. Joshi Marg, Arthur Road Naka, Chinchpokli (W), Mumbai - 400011 (GST: 27CLCPS2523P1ZN).
          </Paragraph>

          <Title level={4}>1. Information We Collect</Title>
          <Paragraph>
            We collect and store the following information:
            <ul>
              <li>Basic personal information (name, mobile number, employee role)</li>
              <li>Attendance records</li>
              <li>Salary information and salary slip data</li>
              <li>Advance payment records</li>
              <li>Device information for authentication purposes</li>
            </ul>
          </Paragraph>

          <Title level={4}>2. How We Use Your Information</Title>
          <Paragraph>
            Your information is used solely for internal HR management purposes:
            <ul>
              <li>Managing employee attendance</li>
              <li>Processing and recording salary payments</li>
              <li>Managing advance payment requests</li>
              <li>Authenticating users and securing access to the system</li>
              <li>Generating reports for management purposes</li>
            </ul>
          </Paragraph>

          <Title level={4}>3. Device Authentication</Title>
          <Paragraph>
            For security purposes, your account can only be accessed from the device where you first logged in. This restriction is in place to prevent unauthorized access to your information. If you need to change your device, please contact the admin to reset your device authentication.
          </Paragraph>

          <Title level={4}>4. Data Access and Control</Title>
          <Paragraph>
            <ul>
              <li>Workers: Can only access their own attendance records, advance logs, and salary slips</li>
              <li>Supervisors: Can access their own records plus attendance and advance logs of all users, and can mark attendance for others</li>
              <li>Admins: Have full access to manage all user data through the web dashboard</li>
            </ul>
          </Paragraph>

          <Title level={4}>5. Account Deletion</Title>
          <Paragraph>
            You may request the deletion of your account through the mobile application. This request will be reviewed by the admin, who will manually process the deletion. Note that certain information may be retained as required by law or for legitimate business purposes.
          </Paragraph>

          <Title level={4}>6. Data Security</Title>
          <Paragraph>
            We implement appropriate security measures to protect your information from unauthorized access, alteration, disclosure, or destruction. Data is stored securely on our servers and is only accessible to authorized personnel.
          </Paragraph>

          <Title level={4}>7. Changes to This Policy</Title>
          <Paragraph>
            We may update this privacy policy from time to time. Any changes will be communicated to you through the application or by your supervisor.
          </Paragraph>

          <Title level={4}>8. Contact Information</Title>
          <Paragraph>
            For any questions about this privacy policy or your personal data, please contact the HR department or system administrator at Devaram Interiors.
          </Paragraph>

          <Paragraph>
            This policy is effective as of 1 August 2024.
          </Paragraph>
        </Typography>
      </Card>
    </div>
  );
};

export default PrivacyPolicy; 